interface Props {
  className?: string;
}

export default function PlaneIcon({className}: Props) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.285 11.036 21 5.25 18.749 3 9.107 6.858 6.072 3.82c-.875-.875-2.097-1.084-2.715-.465-.62.618-.41 1.84.465 2.715l3.035 3.036L3 18.75 5.25 21l5.786-7.714L14.25 16.5V21h2.25l1.125-3.375L21 16.5v-2.25h-4.5l-3.215-3.214z"
      />
    </svg>
  );
}
